import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";

export default function ErrorModal({
  open,
  onClose,
  title = "Atenção",
  errors = [],
}) {
  const isValidationError = title === "Campos obrigatórios";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>{title}</DialogTitle>

      <DialogContent dividers>
        {isValidationError && (
          <DialogContentText
            sx={{ mb: 1, color: "text.secondary", fontSize: 14 }}
          >
            Preencha todos os campos corretamente:
          </DialogContentText>
        )}

        <Box
          component="ul"
          sx={{
            mt: isValidationError ? 1 : 0,
            mb: 0,
            pl: isValidationError ? 3 : 0,
            listStyle: isValidationError ? "disc" : "none",
          }}
        >
          {errors.map((e, idx) => (
            <Box component="li" key={idx} sx={{ mb: 0.5 }}>
              <Typography
                variant="body2"
                sx={{ fontSize: 13, color: "error.main", fontWeight: 500 }}
              >
                {e?.message ?? String(e)}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="success"
          size="small"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
